import { useCallback, useEffect, useState } from 'react'
import { listingType } from './utils'

export const OFFER_DISPLAY_MODE_STORAGE_KEY = 'offerDisplayMode'

const isDisplayMode = (value) => Object.values(listingType).includes(value)

const storedDisplayMode = () => {
  if (typeof window === 'undefined') return listingType.card
  const value = window.localStorage.getItem(OFFER_DISPLAY_MODE_STORAGE_KEY)
  return isDisplayMode(value) ? value : listingType.card
}

const useOfferDisplayMode = (urlMode) => {
  const validUrlMode = isDisplayMode(urlMode) ? urlMode : null
  const [displayMode, setDisplayModeState] = useState(() => validUrlMode || storedDisplayMode())

  useEffect(() => {
    if (!validUrlMode) return
    setDisplayModeState(validUrlMode)
    window.localStorage.setItem(OFFER_DISPLAY_MODE_STORAGE_KEY, validUrlMode)
  }, [validUrlMode])

  const setDisplayMode = useCallback((mode) => {
    if (!isDisplayMode(mode)) return
    setDisplayModeState(mode)
    window.localStorage.setItem(OFFER_DISPLAY_MODE_STORAGE_KEY, mode)
  }, [])

  return [displayMode, setDisplayMode]
}

export default useOfferDisplayMode
